export enum RosterSelectActions {
  Add = 0,
  Remove = 1
}
